export default __webpack_public_path__ + "static/media/new-icon-my-profile-fill.8836a74e.svg";